import type { FC } from 'react'

import { Settings } from '@liveHelper/assets/Settings'
import { SETTINGS_MODAL } from '@liveHelper/components/OneToOneModal/modalIds'
import { useVisitorCanUseCamera } from '@liveHelper/hooks/useVisitorCanUseCamera'
import { selectors } from '@liveHelper/models/modal/modalRegistry'
import { uiStateSelector, useStore } from '@liveHelper/models/store'
import { ActionButton } from '@oneToOne/shared/styles'

import { useContextTranslation } from '@core/i18n'
import { isMobileWeb } from '@core/userAgent'

interface SettingsButtonProps {
  isMinimized?: boolean
}

/**
 * SettingsButton Component
 *
 * A button component for opening video call settings.
 */
export const SettingsButton: FC<SettingsButtonProps> = ({ isMinimized }) => {
  const { t } = useContextTranslation()
  const { showModal } = useStore(selectors.modalActionsSelector)
  const uiState = useStore(uiStateSelector)

  const canUseCamera = useVisitorCanUseCamera()

  return (
    <ActionButton
      aria-label={t(`oneToOne:Open video call settings`)}
      actionType="neutral"
      shape="circle"
      buttonSize={isMinimized ? 'md' : 'lg'}
      icon={
        <Settings
          width={isMinimized ? '18px' : '26px'}
          fill="var(--white)"
          label="settings"
        />
      }
      onClick={() => {
        showModal(SETTINGS_MODAL, 'settings', {
          isChattingOnCallDesktop:
            uiState === 'chatting_on_call' && !isMobileWeb(),
          canUseCamera,
        })
      }}
    />
  )
}
